import { render, staticRenderFns } from "./AddSongLyricsModal.vue?vue&type=template&id=3fc206c5&scoped=true"
import script from "./AddSongLyricsModal.vue?vue&type=script&lang=ts"
export * from "./AddSongLyricsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc206c5",
  null
  
)

export default component.exports